import { substr } from 'runes'

export const substring = (value: string, start: number, end = value.length) =>
  substr(value, start, end - start)
